import { RootState } from 'store';

const MedicationsLookupState = (state: RootState) => state.lookups.medications;

export const selectMedications = (state: RootState) => MedicationsLookupState(state).rows;
